import Api from '../services/Api'

export default function CreateDelivery(params)
{
    let data ={
        userid: params.userid,
        brancheid: params.brancheid._id,
        partenaireid: params.partenaireid._id,
        numero_contrat: params.numeroDevis,
        delivery_cost: localStorage.getItem("delivery_cost"),
        delivery_zone: localStorage.getItem("quartier"),
        delivery_adresse: localStorage.getItem("adressliv"),
        delivery_type: localStorage.getItem("typeLivraison"),
    }
    Api().post('delivery/create', data)
    .then((result) => {
        localStorage.removeItem('delivery_cost');
        localStorage.removeItem('quartier');
        localStorage.removeItem('adressliv');
        localStorage.removeItem('typeLivraison');
    }).catch((err) => {
        localStorage.removeItem('delivery_cost');
        localStorage.removeItem('quartier');
        localStorage.removeItem('adressliv');
        localStorage.removeItem('typeLivraison');
    });
    
}